import {
    breakpoints,
    colors,
    fontFamilies,
    containerPadding,
    breakpointSizes,
} from "@brightagency/headstart-common";
import { transparentize } from "polished";
import styled, { css, keyframes } from "styled-components";
import { buttonResetStyles } from "../../../utils";


const submenuAnimation = keyframes`
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
`;

export const Outer = styled.div<{
    scrolled: boolean;
    fixedHeader: boolean;
    useDarkBackground?: boolean;
    shouldHideBottomBorder?: boolean;
}>`
    position: ${({ fixedHeader }) => (fixedHeader ? "fixed" : "absolute")};
    top: 0;
    width: 100%;
    transition: 200ms ease all;
    background-color: ${({ useDarkBackground }) =>
        useDarkBackground ? colors.brandDark : colors.brandMid};

    ${({ shouldHideBottomBorder }) =>
        shouldHideBottomBorder &&
        css`
            ${Inner} {
                border-bottom: 0;
            }
        `}

    ${({ scrolled }) =>
        scrolled &&
        css`
            box-shadow: 0 2px 5px ${transparentize(0.8, "black")};

            ${breakpoints.custom(breakpointSizes.large, true)} {
                ${Inner} {
                    border-bottom: 0;
                }
            }
        `}

    ${breakpoints.large} {
        position: relative;
        box-shadow: none;
    }
`;

export const Inner = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    border-bottom: 1px solid ${transparentize(0.75, "white")};
    margin-left: -${containerPadding.small}px;
    margin-right: -${containerPadding.small}px;
    padding: 12px ${containerPadding.small}px;

    ${breakpoints.medium} {
        margin-left: 0;
        margin-right: 0;
        padding: 16px 0;
    }

    .single-listing & {
        border: 0 !important;
    }
`;

export const LogoContainer = styled.div`
    flex-grow: 1;

    svg {
        width: 120px;
        height: auto;
    }
`;

const sharedLinkStyled = css`
    ${buttonResetStyles}
    color: ${colors.white};
    font-family: ${fontFamilies.body};
    font-size: 14px;
    font-weight: 500;
    padding: 0 8px;
    text-decoration: none;

    &:focus,
    &:hover {
        color: ${colors.brandLight};
    }
`;

export const Links = styled.div`
    margin: 0 12px;

    > ul {
        display: flex;
        align-items: center;

        > li {
            display: block;
            position: relative;

            > button,
            > a {
                ${sharedLinkStyled}
                display: flex;
                align-items: center;

                svg {
                    margin-left: 8px;
                }
            }

            ul {
                animation: 200ms ease ${submenuAnimation} forwards;
                position: absolute;
                background-color: white;
                width: 225px;
                padding: 0 0;
                margin: 0;
                left: 50%;
                transform: translateX(-50%);
                top: calc(100% + 16px);
                box-shadow: 0 10px 20px ${transparentize(0.8, "black")};
                border-radius: 8px;
                overflow: hidden;

                li {
                    display: block;
                    padding: 0;

                    a {
                        ${sharedLinkStyled}
                        padding: 16px;
                        display: flex;
                        align-items: center;
                        color: ${colors.brandDark};
                        min-height: 40px;
                        line-height: 1;

                        &:focus,
                        &:hover {
                            background-color: hsl(0, 0%, 95%);
                            color: ${colors.brandDark};
                        }
                    }

                    &:not(:last-child) a {
                        border-bottom: 1px solid ${transparentize(0.9, "black")};
                    }
                }
            }
        }
    }
`;

export const Buttons = styled.div`
    display: flex;
    align-items: center;
    margin: 0 -4px;

    > * {
        margin: 0 4px !important;
    }
`;

export const MenuButtonWrapper = styled.div`
    margin-right: -8px;
`;

export const NeedHelpButtonText = styled.span``;

export const TranslateIconLink = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;
